import type { CardDefinition } from "../domain/types/index.js";

export const OVERTIME_CARDS = {
  "overtime-order": {
    id: "overtime-order", name: "残業命令", type: "action",
    text: "2枚引く。行動+1。疲労+1", rewardTier: "medium",
    effect: {
      kind: "compound",
      effects: [
        { kind: "draw", count: 2 },
        { kind: "drawAction", draw: 0, actions: 1 },
        { kind: "fatigue", amount: 1 },
      ],
    },
  },
  "service-overtime": {
    id: "service-overtime", name: "サービス残業", type: "action",
    text: "1枚引く。行動+1。進捗+2。疲労+1", rewardTier: "medium",
    effect: {
      kind: "compound",
      effects: [
        { kind: "draw", count: 1 },
        { kind: "drawAction", draw: 0, actions: 1 },
        { kind: "progress", amount: 2 },
        { kind: "fatigue", amount: 1 },
      ],
    },
  },
  "team-building": {
    id: "team-building", name: "チームビルディング", type: "action",
    text: "手札の労働者1枚につき1枚引く", rewardTier: "medium",
    effect: { kind: "drawPerWorker" },
  },
} as const satisfies Record<string, CardDefinition>;
